export default __webpack_public_path__ + "static/media/404.69b66d0a.svg";